module.exports = __webpack_public_path__ + "static/kira-9b2d8ccf01d95ebcc230abe35a4f9b6e.svg";